import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { generateId } from '../../../shared/utils/generate-id';
import * as cellActions from '../actions/cell.actions';
import { ColumnCell, RootCell, RowCell } from '../types/cell.type';

export const useCell = (
  cell: Omit<RootCell, 'id'> | Omit<RowCell, 'id'> | Omit<ColumnCell, 'id'>,
) => {
  const cellId = useRef(generateId(`cell-${cell.type}`)).current;
  const dispatch = useDispatch();
  const updatedCell = { id: cellId, ...cell };

  useEffect(() => {
    dispatch(
      cellActions.register({
        cell: updatedCell,
        meta: { history: false },
      }),
    );
  }, [dispatch, ...Object.values(updatedCell)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      dispatch(
        cellActions.unregister({
          cellId: updatedCell.id,
          meta: { history: false },
        }),
      );
    };
  }, [dispatch, updatedCell.id]);

  return cellId;
};
